import { z } from 'zod';

const GenericSchema = z.object({
	lastName: z
		.string()
		.optional()
		.describe(
			'The last name of the person. Note that names might be split from a single line and could be in either first-last or last-first order. Leave empty if the name is not present.',
		),
	firstName: z
		.string()
		.optional()
		.describe(
			'The first name of the person. Note that names might be split from a single line and could be in either first-last or last-first order. Initials might be present instead of a full first name. Leave empty if the name is not present.',
		),
	dateOfIssue: z
		.string()
		.optional()
		.describe('The date when the document was issued, in YYYY-MM-DD format. Leave empty if the date is not present.'),
	validUntilDate: z
		.string()
		.optional()
		.describe(
			'The date until which the document is valid, in YYYY-MM-DD format. Leave empty if the date is not present.',
		),
	title: z
		.string()
		.describe(
			'The title of the document or type of qualification (e.g. "basic safety", "working at heights", etc.). Translate to English if needed. Leave empty if the title is not present.',
		),
	documentNumber: z
		.string()
		.optional()
		.describe('The identification number of the document. Leave empty if the number is not present.'),
	documentType: z
		.enum([
			'Certificate',
			"Driver's License",
			'Residence Permit',
			'ID Card',
			'Passport',
			'Limosa',
			'Dimona',
			'A1',
			'Work Permit',
			'Other',
		])
		.describe(
			'The type of document. Look for indicators in the document header, title, or format. ' +
				'- Assign "Certificate" if the document is a qualification or similar. ' +
				'- A Dimona is a document from the "RSZ", "ONSS", or "LSS" with a list of periods of work. ' +
				'- A Limosa is a notification document for cross-border workers. ' +
				'- An A1 is a certificate of coverage for social security. ' +
				'Examples: A VCA certificate should be classified as "Certificate", a Belgian ID card as "ID Card".',
		),
});

export { GenericSchema };
